import { useState } from "react";
import { readJson } from "@jkast90/kast-common/storage";
import { Button, Notice } from "@jkast90/kast-common/ui";
import { ADOPT_NOTICES_KEY } from "../emulator/profiles";

const read = () => readJson<string[]>(ADOPT_NOTICES_KEY, [], { isValid: Array.isArray });

/**
 * What adopting signed-out saves at sign-in did (profiles.ts): a state moved
 * to another slot, or kept back. On every page, the player included, until
 * dismissed.
 */
export default function AdoptedSaves() {
  const [notices, setNotices] = useState(read);
  if (!notices.length) return null;
  return (
    <Notice
      role="status"
      style={{ position: "fixed", left: 16, right: 16, bottom: 16, zIndex: 1000, maxWidth: 560, margin: "0 auto" }}
      actions={
        <Button
          onClick={() => {
            localStorage.removeItem(ADOPT_NOTICES_KEY);
            setNotices([]);
          }}
        >
          OK
        </Button>
      }
    >
      {notices.map((text, i) => (
        <p key={i}>{text}</p>
      ))}
    </Notice>
  );
}
